import Decimal from "decimal.js";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Button, Image, Form } from "react-bootstrap";
import { Modifier } from "react-day-picker";
import reactMoment from "react-day-picker/moment";
import moment from "moment";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import CustomItem from "../../../../../../Data/CustomItem";
import RatesByDate from "../../../../../../Data/Rates/DateRate";
import EnumProductRateType from "../../../../../../Data/Rates/EnumProductRateType";
import ProductRate from "../../../../../../Data/Rates/ProductRate";
import UnitRate from "../../../../../../Data/Rates/UnitRate";
import { getAvailableVendorUnits, getRateTypeFromUnitName, getDailyRate, getHourlyRate, getVendorUnitIdFromUnitName, getUnitNameFromVendorUnitId } from "../../../../../../Data/Rates/UnitRateLogic";
import CustomItineraryUnit from "../../../../../../Data/Reservation/Custom/CustomItineraryUnit";
import VendorUnit from "../../../../../../Data/VendorUnit";
import { roundDecimal, isStringEmpty } from "../../../../../../_helpers/Functions";
import { DatesAndGuests } from "../../../widget-form/WidgetForm";
import Itinerary from "../../../../../../Data/Itinerary";
import CustomDayPickerInput from "../../../../customDayPickerInput/CustomDayPickerInput";
import MobileUnitTabDetails from "../components/MobileUnitTabDetails";
import UseGetCustomVendors, { GetCustomVendorsRequest } from "../../widget-modals/custom/add-custom/data-service-hooks/UseGetCustomVendors";

interface props {
  itinerary: Itinerary;
  item: CustomItineraryUnit;
  vendor: CustomItem;
  itemIndex: number;
  datesAndGuests: DatesAndGuests;
  removeItem: (unit: CustomItineraryUnit) => void;
  editItem: (unit: CustomItineraryUnit) => void;
  bookNowRequested: boolean;
  quoteRequested: boolean;
  quoteStatus: number | undefined;
  onVendorImageClick: (vendor: CustomItem) => void;
  editable: boolean;
}

const CustomItemTab: React.FC<props> = (props) => {
  const { startWidget, style, fromEmail, viewPortBreakPoint, brandSettings, /* brandId */brand } = useContext(WidgetContext);
  const { itinerary, item, itemIndex, datesAndGuests, removeItem, editItem, quoteRequested, bookNowRequested, quoteStatus } = props;

  const brandSetting = brandSettings.find((s: any) => s.brandId === brand?.brandId);

  const [vendor, setVendor] = useState<CustomItem>(props.vendor);
  const [vendorUnits, setVendorUnits] = useState<VendorUnit[]>([]);

  const [startDate, setStartDate] = useState<Date>(moment(item.startDate).toDate());
  const [endDate, setEndDate] = useState<Date>(moment(item.endDate).toDate());
  const [startTimes, setStartTimes] = useState<any[]>([]);
  const [endTimes, setEndTimes] = useState<any[]>([]);
  const [startTime, setStartTime] = useState(item.startTime);
  const [endTime, setEndTime] = useState(item.endTime);
  const [guests, setGuests] = useState(item.numberOfGuests);
  const [units, setUnits] = useState(item.numberOfUnits);
  const maxGuests = datesAndGuests.guests;
  const modifiers = { start: startDate, end: endDate };

  const { formatDate, parseDate } = reactMoment;

  const [currentProductRate, setCurrentProductRate] = useState<ProductRate>();

  const [hourlyRates, setHourlyRates] = useState<UnitRate[]>([]);
  const [isHourlyRate, setIsHourlyRate] = useState<boolean>(false);
  const [unitRates, setUnitRates] = useState<UnitRate[]>([]);
  const [isUnitRate, setIsUnitRate] = useState<boolean>(false);
  const [dayRates, setDayRates] = useState<RatesByDate[]>([]);
  const [isDailyRate, setIsDailyRate] = useState<boolean>(false);
  const [isTimeRate, setIsTimeRate] = useState<boolean>(false);
  const [timeRates, setTimeRates] = useState<ProductRate[]>([]);
  const [unavailableMessage, setUnavailableMessage] = useState<string | undefined>();

  const rates = vendor ? vendor.dailyRates : [];
  const [selectedProductRateType, setSelectedProductRateType] = useState<number | null>(null); //vendorUnit.productRateTypeId
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null); //vendorUnitId
  const [selectedUnitName, setSelectedUnitName] = useState<string | null>(getUnitNameFromVendorUnitId(rates, item.vendorUnitId));

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getCustomVendorsRequest, setGetCustomVendorsRequest] = useState<GetCustomVendorsRequest>();
  const responseGetCustomVendors = UseGetCustomVendors(getCustomVendorsRequest);

  // useEffect(() => {
  //   console.log("selectedUnitName", selectedUnitName);
  // }, [selectedUnitName]);

  const [rangePickerMode, setRangePickerMode] = useState<boolean>(true);

  const [unitRateTotal, setUnitRateTotal] = useState(0);

  const [errorsImg, setErrorsImg] = useState<string | undefined>();
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const vendorImageUrl = errorsImg ? errorsImg : (vendor.description ?
    (vendor.description.vendorDescriptionImages.length > 0 ?
      ((vendor.description.vendorDescriptionImages[0].vendorImageUrl != undefined && vendor.description.vendorDescriptionImages[0].vendorImageUrl.length > 0) ? vendor.description.vendorDescriptionImages[0].vendorImageUrl
        : placeholderImgUrl)
      : placeholderImgUrl)
    : placeholderImgUrl);

  const startDateChanged = (date: Date) => {
    setStartDate(date);
  }

  const endDateChanged = (date: Date) => {
    setStartDate(date);
  }

  // const onGuestsInputChanged = (event: any) => {
  //   setGuests(+event.target.value);
  // };

  const onUnitsInputChanged = (event: any) => {
    setUnits(+event.target.value);
  };

  // this is being sorted AFTER the default rate is selected from the rate sheet
  const unitOptions = vendorUnits.filter(u => !props.editable || u.published).map((unit: VendorUnit, index: number) => (
    <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  ));

  const startTimeOptions = startTimes.map((time: any, index: number) => (
    <option value={time.value} key={index}>{time.label}</option>
  ));

  const endTimeOptions = endTimes.map((time: any, index: number) => (
    <option value={time.value} key={index}>{time.label}</option>
  ));

  function getNumGuestsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    for (let index = 0; index < maxGuests; index++) {
      options.push(<option key={`custom guests option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function getNumUnitsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    for (let index = 0; index < guests; index++) {
      options.push(<option key={`custom units option ${index}`}>{index + 1}</option>);
    }

    return options;
  }
  function getPriceString() {
    if (brandSetting && brandSetting.usePkgPriceByCustom && itinerary.customItineraries && itinerary.customItineraries[0].itineraryUnits.length >= brandSetting.usePkgPriceByCustomNumber) return "Package Price";
    return "$" + (quoteStatus !== undefined ? item.sell.toFixed(2) : (unitRateTotal).toFixed(2));
    // return (0).toFixed(2);
  }

  useEffect(() => {
    setVendor(props.vendor);
    setGetCustomVendorsRequest({ brandId: brand?.brandId as number, startDate: moment(startDate).format('YYYY-MM-DD'), endDate: moment(endDate).format('YYYY-MM-DD'), vendorId: vendor.vendorId });
  }, [props.vendor]);

  useEffect(() => {
    setStartDate(moment(item.startDate).toDate());
    setEndDate(moment(item.endDate).toDate());
    setStartTime(item.startTime);
    setEndTime(item.endTime);
  }, [item])

  useEffect(() => {
    if (vendor === undefined || isLoading) return;

    let _vendorUnits = getAvailableVendorUnits(vendor.vendorUnits, rates, moment(startDate).format("MM/DD/YYYY"));
    _vendorUnits.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      if (a.sortOrder > b.sortOrder) return 1;

      if (a.unitName.toLowerCase() < b.unitName.toLowerCase()) return -1;
      if (a.unitName.toLowerCase() > b.unitName.toLowerCase()) return 1;

      return 0;
    });
    setVendorUnits(_vendorUnits);

    if (_vendorUnits.findIndex(a => a.uniqueIdForSelection == selectedUnitName) < 0) {
      if (_vendorUnits.length > 0) {
        setSelectedUnitName(_vendorUnits[0].uniqueIdForSelection);
      }
    }
  }, [vendor, startDate]);

  useEffect(() => {
    if (vendor === undefined) return;
    setIsDailyRate(false);
    setIsHourlyRate(false);
    setIsUnitRate(false);
    setIsTimeRate(false);

    if (selectedProductRateType == EnumProductRateType.DayRange) {
      setIsDailyRate(true);
      //multiple days
      setRangePickerMode(true);
      // setEndDate(props.maxDate);

      setStartTime("09:00");
      // setEndTime("09:00");
    }
    else if (selectedProductRateType == EnumProductRateType.HoursPerUnit) {
      setIsHourlyRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);

      setStartTime("09:00");
      setEndTime("10:00");

    }
    else if (selectedProductRateType == EnumProductRateType.UnitQtyRange) {
      setIsUnitRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);

      setStartTime("09:00");

    }
    else if (selectedProductRateType == EnumProductRateType.UseTime) {
      setIsTimeRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);

      const unitTimeRates = vendor.dailyRates.flatMap(a => a.unitRates).filter(a => a.vendorUnitDisplayName === selectedUnitName).flatMap(a => a.rates).filter(r => r.rateType == EnumProductRateType.UseTime);
      setTimeRates(unitTimeRates);
    }
    else if (selectedProductRateType == EnumProductRateType.UseUnit) {
      setIsUnitRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);
    }
  }, [selectedProductRateType, vendor]);

  useEffect(() => {
    if (!selectedUnitName) {
      return;
    }

    let rateType = getRateTypeFromUnitName(vendor.dailyRates, selectedUnitName, startDate.toDateString());
    // console.log("rateType", rateType);

    if (rateType == EnumProductRateType.UseTime) {
      const unitTimeRates = rates.flatMap(a => a.unitRates).filter(a => a.vendorUnitDisplayName === selectedUnitName).flatMap(a => a.rates).filter(r => r.rateType == EnumProductRateType.UseTime);
      setTimeRates(unitTimeRates);
    }

    setSelectedProductRateType(rateType);
  }, [selectedUnitName]);

  useEffect(() => {
    if (!timeRates.length) {
      return;
    }
    // Set the start times.
    let newStartTimes: any[] = [];
    timeRates.forEach(r => {
      let start = moment(r.startTime, 'HH:mm');
      let end = moment(r.endTime, 'HH:mm');

      //start.minutes(Math.ceil(start.minutes() / 10) * 10); //this will round up minutes to 10: 8:10, 8:20
      let result: any[] = [];
      let current = moment(start);
      while (current <= end) {
        result.push({
          value: current.format('HH:mm'),
          label: current.format('hh:mm a'),
        });
        current.add(10, 'minutes');
      }
      newStartTimes = newStartTimes.concat(result);
    });
    if (!!newStartTimes.length) {
      newStartTimes = [...new Map(newStartTimes.map(item => [item.value, item])).values()] // Remove any cross-over duplicates.
      newStartTimes.sort((a, b) => {
        // Sort by time.
        return moment(a.value, 'HH:mm').isBefore(moment(b.value, 'HH:mm')) ? -1 : 0;
      });
      setStartTime(newStartTimes[0].value);
    }
    setStartTimes(newStartTimes);
  }, [timeRates, selectedProductRateType, vendor]);

  useEffect(() => {
    if (!(isTimeRate && startTime)) {
      return;
    }

    // Find rate matching the time.
    const dateRates = rates.filter(a => moment(a.date).format('YYYY-MM-DD').toString() === moment(startDate).format('YYYY-MM-DD'));
    const timeRates = dateRates.flatMap(a => a.unitRates).filter(a => a.vendorUnitDisplayName === selectedUnitName).flatMap(a => a.rates);
    const timeRate = timeRates.find(r => moment(r.startTime, 'HH:mm').isSame(moment(startTime, 'HH:mm')));

    if (!timeRate) {
      setUnavailableMessage(`No rates available for the selected time.`)
      setUnitRateTotal(0);
      return;
    }

    setUnavailableMessage('');
    setSelectedUnit(timeRate.vendorUnitId);
    const rate = new Decimal(timeRate.price).times(units);
    setUnitRateTotal(roundDecimal(rate).toNumber());
  }, [isTimeRate, timeRates, startTime, units, startDate, selectedUnitName, vendor]);

  useEffect(() => {
    if (!isDailyRate) {
      return;
    }

    const { productRates, noRateMessage } = getDailyRate(vendor.dailyRates, selectedUnitName, startDate.toDateString(), endDate.toDateString(), startTime, endTime);

    if (!!noRateMessage) {
      setUnavailableMessage(noRateMessage);
      return;
    }

    const rate = productRates.reduce((a, b) => a.add(new Decimal(b ? b.price : 0)), new Decimal(0)).times(units);
    setUnitRateTotal(roundDecimal(rate).toNumber());
    setUnavailableMessage(undefined);
  }, [isDailyRate, dayRates, units, startTime, endTime, startDate, endDate, selectedUnitName, vendor]);

  useEffect(() => {
    if (!(isHourlyRate && startTime && endTime)) {
      return;
    }

    var numberOfHours: number = moment.duration(moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'))).asHours();

    if (numberOfHours < 0) {
      //only 0-24 hours
      numberOfHours = moment.duration(moment(endTime, 'HH:mm').add(1, "day").diff(moment(startTime, 'HH:mm'))).asHours();
    }

    let hourlyRate = getHourlyRate(vendor.dailyRates, selectedUnitName, startTime, endTime);

    if (!hourlyRate) {
      setUnavailableMessage(`No rates available for ${numberOfHours} hours.`);
      setUnitRateTotal(0);
      return;
    }

    const rate = (new Decimal(hourlyRate.price).times(numberOfHours)).times(units);
    setCurrentProductRate(hourlyRate);
    setUnitRateTotal(roundDecimal(rate).toNumber());
    setUnavailableMessage(undefined);
  }, [isHourlyRate, hourlyRates, startTime, endTime, units, selectedUnit, startDate, selectedUnitName, vendor]);

  useEffect(() => {
    if (!isUnitRate) {
      return;
    }

    setUnavailableMessage('');

    //const productRates = unitRates.map(rd => rd.rates[0].rates[0]);
    const dateRates = rates.filter(a => moment(a.date).format('YYYY-MM-DD').toString() === moment(startDate).format('YYYY-MM-DD').toString());
    const unitRates = dateRates.flatMap(a => a.unitRates).filter(a => a.vendorUnitDisplayName === selectedUnitName);
    const productRates = unitRates.flatMap(rd => rd.rates);

    if (productRates.length > 0) {
      setSelectedUnit(productRates[0].vendorUnitId);
      const rate = productRates.reduce((a, b) => a.add(new Decimal(b ? b.price : 0)), new Decimal(0)).times(units);

      setUnitRateTotal(roundDecimal(rate).toNumber());
    }
    else {
      setUnavailableMessage(`No rates available for the selected Date.`)
      setUnitRateTotal(0);
      return;
    }
  }, [isUnitRate, unitRates, units, startDate, selectedUnitName, vendor]);

  useEffect(() => {
    if (quoteRequested || bookNowRequested) {
      item.vendorUnitId = getVendorUnitIdFromUnitName(vendor.dailyRates, selectedUnitName);
      item.startDate = moment(startDate).format("YYYY-MM-DD");
      item.endDate = isDailyRate ? moment(endDate).format("YYYY-MM-DD") : moment(startDate).format("YYYY-MM-DD");
      item.startTime = startTime;
      item.endTime = endTime;
      item.numberOfGuests = guests;
      item.numberOfUnits = units;
      item.sell = unitRateTotal;

      item.isValid = isStringEmpty(unavailableMessage);
    }
  }, [quoteRequested, bookNowRequested]);

  useEffect(() => {
    if (responseGetCustomVendors.data) {
      const responseData = responseGetCustomVendors.data;

      if (responseData.length > 0) {
        setVendor({ ...responseData[0] });
      }
      setIsLoading(false);
    }
  }, [responseGetCustomVendors.data]);

  return (
    <React.Fragment>
      {item.showOnItinerary && (
        <>
          {/* Golf Items */}
          {/* Desktop */}
          <Row className="d-none d-md-flex flex-row item-container">
            {/* Container for Golf Items */}
            {/* Image */}
            <Col
              xs={3}
              className="d-flex flex-row justify-content-start image-col"
            >
              <Image
                style={{ padding: "0" }}
                className="d-flex item-image-desktop"
                // src={""}
                src={vendorImageUrl}
                onClick={() => props.onVendorImageClick(props.vendor)}
                fluid
              />
            </Col>

            {/* Form */}
            <Col xs={10} className="d-flex flex-column pl-3" style={{ maxWidth: 'calc(100% - 250px)' }}>
              <Row>
                <h5
                  className="form-header itinerary-font"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.vendorName : ""}
                </h5>
                <p
                  className="itinerary-font ml-3 mt-3"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.city : ""}, {vendor ? vendor.state : ""}
                </p>
              </Row>

              <div className="d-flex flex-row">
                {/* DatePickers */}
                <Col xs={rangePickerMode ? 4 : 8} className={`d-flex flex-column InputFromTo p-0 ${rangePickerMode ? 'pr-1' : 'pr-0'} mr-1`}>
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Start Date
                  </Form.Label>
                  <CustomDayPickerInput
                    inputProps={{ readOnly: quoteStatus !== undefined, disabled: quoteStatus !== undefined, style: { color: style.fontColor } }}
                    value={moment(startDate).format("ddd, MMM Do, YYYY")}
                    placeholder="Start"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: { from: startDate, to: endDate } as Modifier,
                      disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                      numberOfMonths: 1,
                      month: datesAndGuests.fromDate,
                      modifiers
                    }}
                    onDayChange={startDateChanged}
                  />
                </Col>

                {rangePickerMode && (
                  <Col xs={4} className="d-flex flex-column InputFromTo pr-1 p-0">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      End Date
                    </Form.Label>
                    <CustomDayPickerInput
                      // overlayComponent={MobileDayPickerOverlay}
                      inputProps={{ readOnly: quoteStatus !== undefined, disabled: quoteStatus !== undefined, style: { color: style.fontColor } }}
                      value={moment(item.endDate).format("ddd, MMM Do, YYYY")}
                      placeholder="End"
                      format="LL"
                      formatDate={formatDate}
                      parseDate={parseDate}
                      dayPickerProps={{
                        selectedDays: { from: startDate, to: endDate } as Modifier,
                        disabledDays: { before: moment(startDate).toDate(), after: moment(datesAndGuests.toDate).toDate() },
                        modifiers,
                        numberOfMonths: 1,
                        month: datesAndGuests.fromDate,
                      }}
                      onDayChange={endDateChanged}
                    />
                  </Col>
                )}

                <div className={"d-flex flex-column pl-1"}>
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Units
                      </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor }}
                    as="select"
                    name="units"
                    className="guest-select"
                    defaultValue={units.toString()}
                    onChange={onUnitsInputChanged}
                    readOnly={quoteStatus !== undefined}
                    disabled={quoteStatus !== undefined}
                  >
                    {getNumUnitsOptions()}
                  </Form.Control>
                </div>

                {!isLoading && (
                  <Col xs={3} className="d-flex flex-column m-0 p-0 mr-0 ml-2" style={{ justifyContent: 'flex-end' }}>
                    {/* If the quote is Cancelled showing price is not necessary */}
                    {(props.quoteStatus !== 40 && props.quoteStatus !== 50) && (props.quoteStatus !== 10 || !!!unavailableMessage) && (
                      <div className="add-buttons">
                        <p className="m-0 p-0 text-right font-weight-bold green-text">{!vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showCustomItemsPricing ? getPriceString() : "Package Price"}</p>
                      </div>
                    )}
                    {(props.quoteStatus === 40 || props.quoteStatus === 50) && (
                      <div className="add-buttons">
                        <p className="m-0 p-0 text-right red-text font-italic">{"Cancelled"}</p>
                      </div>
                    )}
                    {(props.quoteStatus === undefined || props.quoteStatus === 10) && unavailableMessage && (
                      <p className="red-text font-italic">{unavailableMessage}</p>
                    )}
                  </Col>
                )}
              </div>

              <div className="d-flex flex-row" style={{ marginTop: "10px" }}>
                {!isLoading && (
                  <>
                    <Col
                      xs={(isTimeRate || isHourlyRate || isDailyRate) ? 4 : 8}
                      className={`d-flex flex-column p-0 ${(isTimeRate || isHourlyRate || isDailyRate) ? 'pr-1' : 'pr-0'}`}
                    >
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Unit Type
                  </Form.Label>
                      <Form.Control
                        style={{ color: style.fontColor }}
                        as="select"
                        name="selectedUnit"
                        className=""
                        readOnly={quoteStatus !== undefined}
                        disabled={quoteStatus !== undefined}
                        value={selectedUnitName || undefined}
                        onChange={(event: any) => {
                          setSelectedUnitName(event.currentTarget.value)
                        }} >
                        <option value="" disabled hidden>Select a unit</option>
                        {unitOptions}
                      </Form.Control>
                    </Col>

                    <Row className="d-flex m-0 p-0 pl-1 mr-0" style={{ width: 'calc(100% - 0.5rem)' }}>
                      {isTimeRate && (
                        <Col xs={(isHourlyRate || isDailyRate) ? 6 : 6} className="d-flex flex-column pr-1 pl-0" style={{ minWidth: 0 }}>
                          <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                            Start Time
                      </Form.Label>
                          <Form.Control
                            style={{ color: style.fontColor }}
                            as="select"
                            name="startTime"
                            className="time-select p-1"
                            value={startTime}
                            onChange={(event: any) => {
                              setStartTime(event.currentTarget.value);
                              // setEndTime(null);
                            }}
                            readOnly={quoteStatus !== undefined}
                            disabled={quoteStatus !== undefined}
                          >

                            {startTimeOptions}
                          </Form.Control>
                        </Col>
                      )}
                      {(isHourlyRate || isDailyRate) && (
                        <Col xs={6} className="d-flex flex-column pl-1 pr-0" style={{ minWidth: 0, whiteSpace: 'nowrap' }}>
                          <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                            End Time
                      </Form.Label>
                          <Form.Control
                            as="select"
                            name="endTime"
                            className="time-select"
                            style={{ color: style.fontColor }}
                            value={endTime}
                            onChange={(event: any) => {
                              setEndTime(event.currentTarget.value)
                            }}
                            readOnly={quoteStatus !== undefined}
                            disabled={quoteStatus !== undefined}
                          >

                            {endTimeOptions}
                          </Form.Control>
                        </Col>
                      )}
                    </Row>
                  </>
                )}

                {(quoteStatus == 20 || quoteStatus == 30 || quoteStatus == 60) && (
                  <Col xs={4} className={`d-flex flex-column m-0 p-0 mr-0 ${(isHourlyRate || isDailyRate) ? 'ml-0 pl-2 pr-1' : 'ml-1 pr-2'}`}>
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Confirmation #
                    </Form.Label>
                    <Form.Control
                      className="font-italic"
                      style={{ color: item.confirmationNumber ? "green" : "red" }}
                      type="text"
                      value={item.confirmationNumber ? item.confirmationNumber : "Pending Confirmation"}
                      readOnly={true}
                      disabled={true}
                    >
                    </Form.Control>
                  </Col>
                )}
                {(quoteStatus == 40 || quoteStatus == 50) && (
                  <Col xs={4} className="d-flex flex-column m-0 p-0 pr-1 mr-0 ml-2">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Cancellation #
                    </Form.Label>
                    <Form.Control
                      className="font-italic"
                      style={{ color: item.cancellationNumber ? "green" : "red" }}
                      type="text"
                      value={item.cancellationNumber ? item.cancellationNumber : "Pending Cancellation"}
                      readOnly={true}
                      disabled={true}
                    >
                    </Form.Control>
                  </Col>
                )}
                {quoteStatus === undefined && props.editable && (
                  <Col
                    className={"d-flex flex-column justify-content-end"}
                  >
                    <Button
                      size="sm"
                      style={{
                        backgroundColor: "#C50505",
                        border: "none",
                        height: "30px",
                        width: 'auto',
                        alignSelf: 'self-end'
                      }}
                      onClick={() => {
                        removeItem(item);
                        // sameDayReplays.splice(itemIndex, 1);
                      }}
                    >
                      Remove
                      </Button>

                    {/* {sameDayReplays.length > 0 && (
                      <Button
                        className="remove-button itinerary-font mt-auto mb-0"
                        onClick={() => {
                          console.log("REMOVE SAME DAY REPLAY CLICKED");
                          // sameDayReplays.splice(itemIndex, 1);
                        }}
                      >
                        REMOVE X
                      </Button>
                    )} */}
                  </Col>
                )}
              </div>
            </Col>
          </Row>

          {/* Mobile  */}
          <MobileUnitTabDetails
            vendor={vendor}
            showPricing={startWidget.showCustomItemsPricing}
            getPriceString={getPriceString}
            editItem={editItem}
            removeItem={removeItem}
            item={item}
            quoteStatus={quoteStatus}
          >
            <h6 style={{ color: style.fontColor, fontSize: 14 }} className="mobile-item-header">{vendor ? vendor.vendorName : ""}</h6>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{moment(startDate).format("MMM Do, YYYY")} - {moment(endDate).format("MMM Do, YYYY")}</p>
            {/* <p className="m-0 p-0">{item.} Guest{item.inUnit == 1 ? "" : "s"}</p> */}
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numberOfUnits ? item.numberOfUnits : 1} Unit{item.numberOfUnits && item.numberOfUnits != 1 ? "s" : ""}
              <span style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">&nbsp;{selectedUnitName}</span>
            </p>
          </MobileUnitTabDetails>
        </>
      )}
    </React.Fragment>
  );
}

export default CustomItemTab;